module.exports = __webpack_public_path__ + "static/img/1788d69956c27b2e(1).73cd629b.png";